// extracted by mini-css-extract-plugin
export default {"container":"Tag_container__Uojkz","default":"Tag_default__lqaGe"};